import { observeStickyCheckoutOffset } from "@tSurya/Common/Utilities/stickyCheckoutOffset";

const EXTRA_GAP_PX = 20;
const OFFSET_LEFT_PX = 22;
const DEFAULT_OFFSET_TOP_PX = 30;

// accessiBe reads --offset-top/--offset-left (inherited through its shadow boundary) to
// reposition its trigger. The standard-page value matches BackToTop's fixed bottom offset.
export default function syncAccessibilityWidgetOffset() {
    if (typeof window === "undefined" || (window as any).surAcsbOffsetSyncInstalled) {
        return;
    }
    (window as any).surAcsbOffsetSyncInstalled = true;

    const start = () => {
        observeStickyCheckoutOffset(height => {
            const accessibilityWidgets = document.querySelectorAll<HTMLElement>("access-widget-ui");
            if (height > 0) {
                const offsetTop = `${Math.ceil(height) + EXTRA_GAP_PX}px`;
                accessibilityWidgets.forEach(widget => {
                    widget.style.setProperty("--offset-top", offsetTop);
                    widget.style.setProperty("--offset-left", `${OFFSET_LEFT_PX}px`);
                });
            } else {
                accessibilityWidgets.forEach(widget => {
                    widget.style.setProperty("--offset-top", `${DEFAULT_OFFSET_TOP_PX}px`);
                    widget.style.setProperty("--offset-left", `${OFFSET_LEFT_PX}px`);
                });
            }
        });
    };

    if (document.body) {
        start();
    } else {
        window.addEventListener("DOMContentLoaded", start, { once: true });
    }
}
